type Props = {
  fill: string;
  width?: number;
  height?: number;
};
function IntervalIconSvg(props: Props) {
  const { fill, width = 16, height = 16 } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_1189_2590)">
        <path
          d="M13 4C14.1046 4 15 3.10457 15 2C15 0.89543 14.1046 0 13 0C11.8954 0 11 0.89543 11 2C11 3.10457 11.8954 4 13 4Z"
          fill={fill}
        />
        <path
          d="M15.7074 5.2936C15.3168 4.90297 14.684 4.90297 14.2934 5.2936L13.0004 6.58657L8.70742 2.2936C8.43887 2.02455 8.04238 1.93129 7.68398 2.0519L4.68398 3.0519C4.16006 3.2267 3.87686 3.79311 4.05166 4.31703C4.22647 4.84096 4.78994 5.12563 5.3168 4.94936L7.73037 4.14467L8.63168 5.04598L6.65664 7.02065C6.17324 7.50453 5.93496 8.1725 6.00234 8.85317C6.07021 9.53285 6.43496 10.1403 7.08438 10.5675L8.5585 11.3605L7.16836 13.4459C6.86221 13.9054 6.98623 14.5265 7.4457 14.8327C7.90363 15.1384 8.52557 15.0152 8.83242 14.5553L10.8324 11.5553C11.1594 11.0649 10.9928 10.3996 10.474 10.1198L8.11221 8.85463C7.96747 8.75787 7.95068 8.55522 8.07119 8.43471L10.0458 6.4601L12.2934 8.70766C12.684 9.0983 13.3168 9.0983 13.7074 8.70766L15.7074 6.70766C16.098 6.31703 16.098 5.68422 15.7074 5.2936Z"
          fill={fill}
        />
        <path
          d="M4.29297 10.293L0.292969 14.293C-0.0976562 14.6836 -0.0976562 15.3164 0.292969 15.707C0.488281 15.9023 0.744141 16 1 16C1.25586 16 1.51172 15.9023 1.70703 15.707L5.70703 11.707C6.09766 11.3164 6.09766 10.6836 5.70703 10.293C5.31641 9.90234 4.68359 9.90234 4.29297 10.293Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}

export default IntervalIconSvg;
